import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Modal, TableBody } from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import CreateSubscriptionPackage from "../../components/subscripitonPackage/CreateSubscriptionPackage";
import { ALL_SUB_PACKAGES } from "../../gql/subscriptionPakcage";
import {
  LoadingModal,
  DataTable,
  DataTableCell,
  DataTablePagination,
  DataTableRow,
  ListPageLayout,
  RowActions,
} from "../../components/layout";

const COLUMNS = [
  { id: "id", label: "ID", minWidth: 60 },
  { id: "title", label: "Title", minWidth: 140 },
  { id: "description_en", label: "Description Eng", minWidth: 180 },
  { id: "description_mm", label: "Description MM", minWidth: 180 },
  { id: "created", label: "Created At", minWidth: 120 },
  { id: "actions", label: "Actions", minWidth: 100 },
];

const SubscriptionPakcages = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [subPackages, setSubPackages] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const [loadSubPakcages, result] = useLazyQuery(ALL_SUB_PACKAGES);

  useEffect(() => {
    loadSubPakcages({
      variables: {
        limit: rowsPerPage,
        offset: offset,
        search: `%${search}%`,
      },
      fetchPolicy: "network-only",
    });
  }, [loadSubPakcages, offset, search, rowsPerPage]);

  useEffect(() => {
    if (result.data) {
      setSubPackages(result?.data?.subscription_packages);
      setCount(
        Number(result.data?.subscription_packages_aggregate?.aggregate.count)
      );
    }
  }, [result]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchValue);
    setPage(0);
    setOffset(0);
  };

  if (!subPackages) {
    return <LoadingModal open message="Loading..." />;
  }

  return (
    <>
      <ListPageLayout
        breadcrumbs={[
          { label: "Dashboard", to: "/user" },
          { label: "Subscription Packages" },
        ]}
        title="Subscription Packages"
        subtitle="Manage subscription packages and pricing tiers."
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Search by title"
        showFilters={false}
      >
        <DataTable
          columns={COLUMNS}
          isEmpty={subPackages.length === 0}
          emptyMessage="No packages found"
        >
          <TableBody>
            {subPackages.map((row, index) => (
              <DataTableRow key={row.id}>
                <DataTableCell>{page * rowsPerPage + index + 1}</DataTableCell>
                <DataTableCell>
                  {row.title?.substring(0, 20)}....
                </DataTableCell>
                <DataTableCell>
                  {row?.description_en
                    ?.map((m) => m?.substring(0, 15))
                    .join(" , ")}
                </DataTableCell>
                <DataTableCell>
                  {row?.description_mm
                    ?.map((m) => m?.substring(0, 15))
                    .join(" , ")}
                </DataTableCell>
                <DataTableCell>{row.created_at?.substring(0, 10)}</DataTableCell>
                <DataTableCell>
                  <RowActions
                    viewLabel="Detail"
                    onView={() => navigate(`/sub_package/${row.id}`)}
                  />
                </DataTableCell>
              </DataTableRow>
            ))}
          </TableBody>
        </DataTable>

        <DataTablePagination
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          entityLabel="packages"
        />
      </ListPageLayout>

      <Modal
        keepMounted
        open={createOpen}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        sx={{
          overflow: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Box sx={{ maxWidth: 800, width: "100%", outline: "none" }}>
          <CreateSubscriptionPackage />
        </Box>
      </Modal>
    </>
  );
};

export default SubscriptionPakcages;
